import React, { useEffect, useRef, useState } from 'react';
import chain1 from "../assets/product/chain1.png";
import chain2 from "../assets/product/chain2.png";
import chain3 from "../assets/product/chain3.png";
import chain4 from "../assets/product/chain4.png";
import chain5 from "../assets/product/chain5.png";
import chain6 from "../assets/product/chain6.png";
import chain7 from "../assets/product/chain7.png";
import chain8 from "../assets/product/chain8.png";
import chain9 from "../assets/product/chain9.png";
import chain10 from "../assets/product/chain1.png";
import chain11 from "../assets/product/chain2.png";
import chain12 from "../assets/product/chain3.png";
import goldChain from "../assets/product/goldchain.png";
import goldRing from "../assets/product/goldring.png";
import goldEaring from "../assets/product/goldearing.png";
import namePlate from "../assets/product/daimondnameplate.png";
import icedGoldEaring from "../assets/product/goldicedearing.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Import Swiper React components
import Slider from "react-slick"; // Import Slick Slider
// Import Slick styles
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import CategoriesService from '../services/API/CategoriesService';
import { Link, useParams } from 'react-router-dom';
import ProductServices from '../services/API/ProductServices';
import { BASE_URL } from '../services/Constant';

const Main2 = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };


      const [category, setCategory] = useState([]);
      const [categoryProducts, setCategoryProducts] = useState([]);
      const { id } = useParams();
  
      const fetchCategoryData = async () => {
        try {
          const res = await CategoriesService.getCategoryById(id);
          setCategory(res.data);
          setCategoryProducts(res.data.products);
        
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };
      useEffect(() => {
        fetchCategoryData(id);
      }, []);
      console.log(category);
           
      
      const [products, setProducts] = useState([]);
    
      const activeProductData = async () => {
        try {
          const res = await ProductServices.all();
          if (res.status) {
            setProducts(res.data);
            console.log('data', res.data);
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };
    
      useEffect(() => {
        activeProductData();
      }, []);
    
      const shuffleArray = (array) => {
        return array.sort(() => Math.random() - 0.5);
      };
    
      const shuffledProducts = shuffleArray([...products]); // Shuffle products array
    
      // Slick Slider Settings
   const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
      if (isLoading) {
        return (
          <div className="flex justify-center items-center py-16 bg-[#fff]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#F4CF38]"></div>
      </div>
        );
      }
  return (
    <>
      <div className='container'>
        <div className='category-sec2'>
          <h2 className='category-sec2-text'>{category.name}</h2>
        </div>
        <div className='category-sec2-flt-main-div'>
          <div className='category-sec2-flt-lft-div'>
            <h6>Filter:</h6>
            <div className='category-sec2-flt-lft-fltr-div'>
              <div className='category-sec2-flt-div'>
                <select value={selectedOption} onChange={handleChange}>
                  <option value="">Color</option>
                  <option value="option1">Red</option>
                  <option value="option2">Green</option>
                  <option value="option3">Blue</option>
                  <option value="option4">Yellow</option>
                </select>
              </div>
              <div className='category-sec2-flt-div'>
                <select value={selectedOption} onChange={handleChange}>
                  <option value="">Size</option>
                  <option value="option1">Red</option>
                  <option value="option2">Green</option>
                  <option value="option3">Blue</option>
                  <option value="option4">Yellow</option>
                </select>
              </div>
              <div className='category-sec2-flt-div'>
                <select value={selectedOption} onChange={handleChange}>
                  <option value="">Lenght</option>
                  <option value="option1">Red</option>
                  <option value="option2">Green</option>
                  <option value="option3">Blue</option>
                  <option value="option4">Yellow</option>
                </select>
              </div>
              <div className='category-sec2-flt-div'>
                <select value={selectedOption} onChange={handleChange}>
                  <option value="">Width</option>
                  <option value="option1">Red</option>
                  <option value="option2">Green</option>
                  <option value="option3">Blue</option>
                  <option value="option4">Yellow</option>
                </select>
              </div>
            </div>
          </div>
          <div className='category-sec2-flt-rht-div'>
            <h6>Sort by: </h6>
            <div className='category-sec2-flt-rht-fltr-div'>
              <div className='category-sec2-flt-div'>
                <select value={selectedOption} onChange={handleChange}>
                  <option value="">Featured</option>
                  <option value="option1">Red</option>
                  <option value="option2">Green</option>
                  <option value="option3">Blue</option>
                  <option value="option4">Yellow</option>
                </select>
              </div>
              <span>782 Products</span>
            </div>
          </div>
        </div>
        <div className='category-sec3-main-div'>
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
        {categoryProducts.length > 0 ? (
            categoryProducts.map((product) => (
               <Link key={product.id} to={`/product/${product.id}`} className='block bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1 text-left'>
                            <div className='relative h-48 w-full overflow-hidden rounded-lg'>
                                                                      <img
                                                                                                        src={product.productImage}
                                                                                                        alt={product.name}
                                                                        className='w-full h-full object-contain mx-auto'
                                                                      />
                                                                    </div>
                            <h4 className='mt-4 text-lg font-semibold text-gray-800'>{product.name.split(" ").slice(0, 4).join(" ")}{product.name.split(" ").length > 4 ? "..." : ""}</h4>
                            <span className='text-gray-600 text-md font-medium'>${product.price}</span>
                          </Link>
                // <div key={product.id} className='product-sec3-card-swiper' style={{ width: "fit-content" }}>
                //   <Link to={`/product/${product.id}`}>
                //   <div className='category-sec3-card'>
                //     <div className='category-sec3-img-div'>
                //       <img variant="top" src={product.productImage} />
                //     </div>
                //     <h4>{product.name}</h4>
                //     <span>
                //       ${product.price}
                //     </span>
                //   </div>
                //   </Link>
                // </div>
               ))
              ) : (
                <p>No Products Yet</p>
              )}
          </div>
        </div>
        <h2 className='category-sec4-eplore-h2'>EXPLPORE MORE PRODUCTS</h2>
      </div>
      <div className='product-sec2-slider'>
        <div>
          <Carousel
              responsive={responsive}
              
              itemClass="carousel-item-padding-40-px"
              >
          {shuffledProducts.map((product, index) => (
            <Link key={index} to={`/product/${product.id}`} className='block bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1 text-left mx-3'>
                                                    <div className='relative h-48 w-full overflow-hidden rounded-lg'>
                                                      <img
                                                        src={`${BASE_URL}${product.image}`} alt={product.name}
                                                        className='w-full h-full object-contain mx-auto'
                                                      />
                                                    </div>
                                                    <h4 className='mt-4 text-lg font-semibold text-gray-800'>{product.name.split(" ").slice(0, 4).join(" ")}{product.name.split(" ").length > 4 ? "..." : ""}</h4>
                                                    <span className='text-gray-600 text-md font-medium'>${product.price}</span>
                                                  </Link>
          ))}
        </Carousel>
        </div>
      </div>
    </>
  )
}

export default Main2